import React from 'react';

export default function CarouselBlockConfig({ data, onChange }) {
  const images = data.images || [];

  const updateImage = (index, field, value) => {
    const newImages = [...images];
    newImages[index] = { ...newImages[index], [field]: value };
    onChange({ ...data, images: newImages });
  };

  const addImage = () => {
    onChange({ ...data, images: [...images, { src: '', alt: '', caption: '' }] });
  };

  const removeImage = (index) => {
    onChange({ ...data, images: images.filter((_, i) => i !== index) });
  };

  return (
    <>
      <div className="adminblog-field">
        <label>
          <input type="checkbox" checked={data.fullWidth === true} onChange={(e) => onChange({ ...data, fullWidth: e.target.checked })} style={{ marginRight: 8 }} />
          Ancho completo (una foto por slide, pie debajo)
        </label>
      </div>
      {!data.fullWidth && (
        <div className="adminblog-field">
          <label>Visible Items</label>
          <select value={data.visibleItems || 2} onChange={(e) => onChange({ ...data, visibleItems: parseInt(e.target.value) })}>
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
          </select>
        </div>
      )}
      <div className="adminblog-field">
        <label>
          <input type="checkbox" checked={data.rounded !== false} onChange={(e) => onChange({ ...data, rounded: e.target.checked })} style={{ marginRight: 8 }} />
          Bordes redondeados
        </label>
      </div>
      <div className="adminblog-field">
        <label>
          <input type="checkbox" checked={data.showCaptions !== false} onChange={(e) => onChange({ ...data, showCaptions: e.target.checked })} style={{ marginRight: 8 }} />
          Mostrar pies de foto
        </label>
      </div>
      <div className="adminblog-field">
        <label>Images ({images.length})</label>
        {images.map((img, i) => (
          <div key={i} className="adminblog-list-item" style={{ flexWrap: 'wrap' }}>
            <input type="text" value={img.src} onChange={(e) => updateImage(i, 'src', e.target.value)} placeholder="Image URL" />
            <input type="text" value={img.alt || ''} onChange={(e) => updateImage(i, 'alt', e.target.value)} placeholder="Alt" style={{ maxWidth: 80 }} />
            <button className="adminblog-list-remove" onClick={() => removeImage(i)}>×</button>
            <input type="text" value={img.caption || ''} onChange={(e) => updateImage(i, 'caption', e.target.value)} placeholder="Pie de foto (caption)" style={{ flexBasis: '100%', marginTop: 6 }} />
          </div>
        ))}
        <button className="adminblog-list-add" onClick={addImage}>+ Add Image</button>
      </div>
    </>
  );
}
